import {
  Layers, Bot, Shield, Star, Palette, ShoppingBag, Calendar,
  Video, PenLine, Newspaper, Sparkles, Zap, Globe, Cpu, Mail,
  CreditCard, KeyRound,
} from 'lucide-react';

export const ICON_MAP = {
  Layers, Bot, Shield, Star, Palette, ShoppingBag, Calendar,
  Video, PenLine, Newspaper, Sparkles, Zap, Globe, Cpu, Mail,
  CreditCard, KeyRound,
};

export function resolveIcon(name) {
  return ICON_MAP[name] || Sparkles;
}
